import * as React from 'react'
import * as css from './InteractiveDetails.module.css'
import { GlobalContext } from 'components/Store'
import { isMobile } from 'react-device-detect'
import clsx from 'clsx'

export default function InteractiveDetails({
	id,
	summary,
	children,
	contentClassName,
}) {
	const { $headerMenu, set$headerMenu } = React.useContext(GlobalContext)

	function onClick(e) {
		e.preventDefault()

		if ($headerMenu === id) {
			set$headerMenu(false)
		} else {
			set$headerMenu(id)
		}
	}

	const handleDropdown = isMobile
		? { onClick }
		: { onMouseEnter: () => set$headerMenu(id) }

	return (
		<details className={css.root} open={$headerMenu === id}>
			<summary
				className={clsx(
					css.summary,
					'technical-lg relative block md:text-sm <md:py-[0.5em]',
				)}
				{...handleDropdown}
			>
				{summary}
			</summary>

			<div
				className={clsx(
					'anim-fade-to-b top-full md:absolute md:z-[1]',
					contentClassName,
				)}
			>
				{children}
			</div>
		</details>
	)
}
